interface IProductConfig {
    id: string;
    name?: string;
    nameLc?: string;
    appInstances: string[];
    getUrl: (urlConfig: UrlConfig) => string;
    shortDescription?: string;
    icon?: string;
    iconClass?: string;
}

interface UrlConfig {
    tenant?: string;
    dotEnv: string;
    dashEnv: string;
    domain: string;
}

export const MRDM_PRODUCTS: IProductConfig[] = [
    {
        id: "codman",
        name: "Codman",
        appInstances: [
            "ApplicationInstance.CodmanIndicators.CA",
            "ApplicationInstance.CodmanDescriptives.CA",
            "ApplicationInstance.CodmanIndicators.NL",
            "ApplicationInstance.CodmanDescriptives.NL",
            "ApplicationInstance.CodmanExploration.NL",
            "ApplicationInstance.CodmanPatients.NL",
            "ApplicationInstance.CodmanPatients2.CodmanPatientsNL",
        ],
        getUrl: ({ tenant, dotEnv, domain }: UrlConfig) => {
            return `https://codman.${tenant ?? "dica"}${dotEnv}.${domain}/`;
        },
        // shortDescription: "CDM2021",
        iconClass: "codman-tool-icon",
    },
    {
        id: "survey",
        name: "DataEntry",
        appInstances: ["ApplicationInstance.Survey.NL"],
        getUrl: ({ dotEnv, domain }: UrlConfig): string => {
            const currentDotEnv = dotEnv === ".staging" ? ".accept" : dotEnv;
            return `https://dataentry${currentDotEnv}.${domain}/select`;
        },
        // shortDescription: "SRV021",
        iconClass: "survey-tool-icon",
    },
    {
        id: "dataConnect",
        name: "Data Connect",
        appInstances: ["ApplicationInstance.DataConnect.NL"],
        getUrl: ({ dotEnv, domain }: UrlConfig) => {
            return `https://data-connect${dotEnv}.${domain}/`;
        },
        // shortDescription: "DCN2021",
        iconClass: "data-connect-tool-icon",
    },
    {
        id: "medicine",
        nameLc: "APP._Shared.Applications.Medicine.Name",
        appInstances: ["ApplicationInstance.CodmanMedicine.NL"],
        getUrl: () => `https://mva.mrdm.nl.logex.com/`,
        // shortDescription: "MED2021",
        iconClass: "medicine-tool-icon",
    },
    {
        id: "data-request",
        nameLc: "APP._Shared.Applications.DataRequest.Name",
        appInstances: ["ApplicationInstance.DataRequest.NL"],
        getUrl: ({ dotEnv, domain }: UrlConfig) => {
            return `https://data-request${dotEnv}.${domain}/`;
        },
        // shortDescription: "DRA",
        iconClass: "data-request-tool-icon",
    },
    {
        id: "patients-like-me",
        nameLc: "APP._Shared.Applications.Patients-like-me.Name",
        appInstances: ["ApplicationInstance.CodmanPatients.NL"],
        getUrl: ({ dotEnv, domain }: UrlConfig) => {
            return `https://codman-patients.dica${dotEnv}.${domain}/`;
        },
        // shortDescription: "DRA",
        iconClass: "patients-tool-icon",
    },
    {
        id: "patients",
        nameLc: "APP._Shared.Applications.Patients.Name",
        appInstances: ["ApplicationInstance.CodmanPatients2.CodmanPatientsNL"],
        getUrl: ({ dotEnv, domain }: UrlConfig) => {
            return `https://codman-patients.dica${dotEnv}.${domain}/`;
        },
        // shortDescription: "DRA",
        iconClass: "patients-tool-icon",
    },
];
